"use strict";

require("core-js/modules/es6.array.filter.js");

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

require("core-js/modules/es6.array.find.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _localeConsumerDecorator = require("../../utils/localeConsumerDecorator");

var _style = require("./style");

var _style2 = require("../RegionMenu/style");

var _RegionMenu = _interopRequireDefault(require("../RegionMenu"));

var _zh_CN = _interopRequireDefault(require("./locale/zh_CN"));

var _this5 = void 0;

var _excluded = ["options", "regionMenuProps", "popoverProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var optionsShape = {
  /**
   * item的唯一键
   */
  value: _propTypes["default"].any,

  /**
   * item的展示文本
   */
  label: _propTypes["default"].string,

  /**
   * category的名称
   */
  category: _propTypes["default"].string,

  /**
   * 国旗/区旗图标ID
   */
  flag: _propTypes["default"].string,

  /**
   * 是否禁用
   */
  disabled: _propTypes["default"].bool,

  /**
   * 角标配置，默认不显示
   */
  bubble: _propTypes["default"].object,

  /**
   * tooltip配置，默认不显示
   */
  tooltip: _propTypes["default"].object
};
/**
 * RegionSelect
 * @description 地域选择表单控件
 */

var RegionSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RegionSelect, _Component);

  var _super = _createSuper(RegionSelect);

  function RegionSelect(props) {
    var _this2 = this;

    var _this;

    (0, _classCallCheck2["default"])(this, RegionSelect);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedOption", function (value, options) {
      var _this3 = this;

      (0, _newArrowCheck2["default"])(this, _this2);
      return options.find(function (option) {
        (0, _newArrowCheck2["default"])(this, _this3);
        return option.value === value;
      }.bind(this));
    }.bind(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderContent", function (value) {
      (0, _newArrowCheck2["default"])(this, _this2);
      var _this$props = _this.props,
          options = _this$props.options,
          disabled = _this$props.disabled,
          locale = _this$props.locale,
          _this$props$placehold = _this$props.placeholder,
          placeholder = _this$props$placehold === void 0 ? locale.placeholder : _this$props$placehold;

      if (value === undefined) {
        return placeholder;
      } else {
        var selectedOption = _this.getSelectedOption(value, options);

        if (selectedOption) {
          var contentLabel = selectedOption.label || selectedOption.value;
          return /*#__PURE__*/_react["default"].createElement(_style.StyledContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactComponents.Combine, null, selectedOption.flag && /*#__PURE__*/_react["default"].createElement(_style2.StyledRegionFlag, {
            id: selectedOption.flag,
            disabled: disabled
          }), contentLabel));
        }

        return /*#__PURE__*/_react["default"].createElement(_style.StyledContentWrapper, null, value);
      }
    }.bind(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderPopup", function (_ref) {
      var _this4 = this;

      (0, _newArrowCheck2["default"])(this, _this2);
      var handleVisible = _ref.handleVisible,
          onChange = _ref.onChange,
          value = _ref.value;
      var _this$props2 = _this.props,
          options = _this$props2.options,
          regionMenuProps = _this$props2.regionMenuProps;
      return /*#__PURE__*/_react["default"].createElement(_RegionMenu["default"], (0, _extends2["default"])({
        dataSource: options,
        value: value,
        onChange: function (val) {
          (0, _newArrowCheck2["default"])(this, _this4);
          handleVisible(false);
          onChange(val);
        }.bind(this)
      }, regionMenuProps));
    }.bind(this));
    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass2["default"])(RegionSelect, [{
    key: "render",
    value: function render() {
      /* eslint-disable react/prop-types */
      var _this$props3 = this.props,
          options = _this$props3.options,
          regionMenuProps = _this$props3.regionMenuProps,
          popoverProps = _this$props3.popoverProps,
          others = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.Select, (0, _extends2["default"])({}, others, {
        renderContent: this.renderContent,
        renderPopup: this.renderPopup,
        popoverProps: _objectSpread({
          forwardPopupContainer: true
        }, popoverProps)
      }));
    }
  }]);
  return RegionSelect;
}(_react.Component);

RegionSelect.propTypes = {
  /**
   * 	当前值，controlled
   */
  value: _propTypes["default"].any,

  /**
   * 	默认值，uncontrolled
   */
  defaultValue: _propTypes["default"].any,

  /**
   * 	无选项时显示内容
   */
  placeholder: _propTypes["default"].node,

  /**
   * 	修改时的回调
   */
  onChange: _propTypes["default"].func,

  /**
   * 	是否禁用
   */
  disabled: _propTypes["default"].bool,

  /**
   * 	选项
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape(optionsShape)),

  /** 尺寸 */
  size: _propTypes["default"].oneOf(["sm", "md", "lg"]),

  /** 地域选择弹出菜单的 props */
  regionMenuProps: _propTypes["default"].object,

  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  locale: _propTypes["default"].object
};
RegionSelect.defaultProps = {
  onChange: function onChange() {
    (0, _newArrowCheck2["default"])(this, _this5);
  }.bind(void 0),
  size: "md"
};

var _default = (0, _localeConsumerDecorator.localeConsumerDecorator)({
  defaultLocale: _zh_CN["default"],
  localeName: "UI_RegionSelect"
})(RegionSelect);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/RegionSelect/RegionSelect.js
// module id = 2147
// module chunks = 6 7 17 18